module.exports = __webpack_public_path__ + "static/media/bf.0ca6be29.webp";